// extracted by mini-css-extract-plugin
export default {"title":"BloggerAudioAi_title__FjGwI","content":"BloggerAudioAi_content__FulSo"};